import { DashboardWidgetUnion } from '../types';

export const getDashboardWidgetPosition = (
  widget: DashboardWidgetUnion,
  orientation: 'portrait' | 'landscape',
  dimensions?: { width: number; height: number }
) => {
  const position =
    widget.positions[orientation] || Object.values(widget.positions)[0];

  if (dimensions) {
    const { width, height } = dimensions;

    return {
      width: position.width * width,
      height: position.height * height,
      left: position.left * width,
      top: position.top * height,
    };
  } else {
    return position;
  }
};

export const getDashboardWidgetCoordinates = (
  widget: DashboardWidgetUnion,
  orientation: 'portrait' | 'landscape'
) => {
  const position = getDashboardWidgetPosition(widget, orientation);

  return {
    x: position.left,
    y: position.top,
    w: position.width,
    h: position.height,
  };
};
